import jsonToCsv from 'json-to-csv-export';
import { call, type SagaGenerator } from 'typed-redux-saga';
import { usersApiClient } from '@owl-frontend/api-client';
import { asyncActionStateMatchers, invoke } from '@owl-frontend/redux';
import usersSlice from './interface';

function* downloadUsers(): SagaGenerator<{ numDownloaded: number }> {
  const users = yield* call(usersApiClient.users.list);

  yield* call(jsonToCsv, {
    data: users.map((u) => ({
      'User ID': u.email ?? '-',
      Name: u.name ?? '-',
      Role: u.role ?? 'investigator',
    })),
    filename: `users-report.csv`,
    delimiter: ',',
  });
  return { numDownloaded: users.length };
}
const slice = usersSlice
  .addAsyncSagas({
    downloadUsers,
    createUser: invoke(usersApiClient.users.create),
    listUsers: invoke(usersApiClient.users.list),
    deleteUser: invoke(usersApiClient.users.delete),
    updateUserRole: invoke(usersApiClient.users.updateUserRole),
    updateUserSettings: invoke(usersApiClient.users.updateUserSettings),
    updateEmailSubscriptions: invoke(
      usersApiClient.users.updateEmailSubscriptions
    ),
  })
  .addReducers({
    'listUsers/fulfilled': (state, action) => {
      state.users = action.payload;
    },
  });
export const actions = slice.actions;
export default slice.addExtra(
  asyncActionStateMatchers(actions)
    .all()
    .config({ createUser: { storeRequestArg: true } })
);
